var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAilines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 569,
    height: 663,
    viewBox: "0 0 569 663",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.987 33.0629C531.987 33.0629 538.101 38.2431 547.326 40.1631C556.55 42.0831 563.181 47.6061 563.181 47.6061",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.814 31.4976C506.814 31.4976 516.522 48.5301 536.663 54.0804C556.235 59.4192 565.926 76.8954 565.926 76.8954",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.656 29.9862C481.656 29.9862 494.955 58.8503 525.937 67.9686C555.794 76.7539 568.682 106.171 568.682 106.171",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.41 28.4572C456.41 28.4572 473.364 69.1093 515.196 81.8829C555.401 94.0718 571.412 135.379 571.412 135.379",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.228 26.9231C431.228 26.9231 451.771 79.4022 504.444 95.7406C554.933 111.373 574.139 164.616 574.139 164.616",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.068 25.4061C406.068 25.4061 430.2 89.7118 493.787 109.663C554.487 128.69 576.888 193.87 576.888 193.87",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.835 23.8921C380.835 23.8921 408.619 99.9837 482.983 123.54C554.104 146.017 579.632 223.129 579.632 223.129",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.667 22.3864C355.667 22.3864 387.039 110.304 472.317 137.473C553.649 163.344 582.371 252.392 582.371 252.392",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.494 20.8553C330.494 20.8553 365.455 120.599 461.578 151.377C553.189 180.646 585.101 281.585 585.101 281.585",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.28 19.3543C305.28 19.3543 343.825 130.88 450.86 165.27C552.829 198.031 587.863 310.857 587.863 310.857",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.111 17.841C280.111 17.841 322.312 141.196 440.125 179.191C552.373 215.349 590.602 340.111 590.602 340.111",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.941 16.317C254.941 16.317 300.731 151.498 429.452 193.06C551.916 232.657 593.34 369.355 593.34 369.355",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.699 14.7917C229.699 14.7917 279.073 161.754 418.645 206.97C551.524 249.973 596.069 398.557 596.069 398.557",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.557 13.3038C204.557 13.3038 257.519 172.092 407.931 220.871C551.095 267.317 598.834 427.837 598.834 427.837",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.311 11.7767C179.311 11.7767 235.93 182.395 397.187 234.783C550.63 284.626 601.564 457.082 601.564 457.082",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.154 10.2567C154.154 10.2567 214.356 192.656 386.458 248.652C550.253 301.941 604.313 486.329 604.313 486.329",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.977 8.72395C128.977 8.72395 192.767 202.949 375.782 262.557C549.789 319.241 607.043 515.564 607.043 515.564",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.727 7.2114C103.727 7.2114 171.174 213.266 364.966 276.479C549.32 336.564 609.764 544.779 609.764 544.779",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5806 5.70799C78.5806 5.70799 149.611 223.544 354.317 290.369C548.955 353.897 612.525 574.042 612.525 574.042",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4268 4.18408C53.4268 4.18408 128.046 233.846 343.596 304.279C548.513 371.204 615.278 603.286 615.278 603.286",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1766 2.66088C28.1766 2.66088 106.384 244.148 332.843 318.15C548.045 388.517 618.004 632.534 618.004 632.534",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99936 1.14377C2.99936 1.14377 84.8581 254.416 322.099 332.067C547.648 405.836 620.729 661.74 620.729 661.74",
    stroke: "#0088FF",
    strokeWidth: 6.01778,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAilines);
export default __webpack_public_path__ + "static/media/ailines.f772b682fb199d5952c41972770e2b0e.svg";
export { ForwardRef as ReactComponent };